import { useCallback } from 'react';

import { useAgeVerificationModal } from '@/modals';

import { useUser } from '@/entities/user/model/user.store';

export const useAgeVerification = () => {
  const user = useUser();
  const { open } = useAgeVerificationModal();

  const rawValue = user?.tests?.custom?.ageConfirmation;
  const isAgeConfirmed = !!rawValue && !isNaN(Date.parse(rawValue));

  const openAgeConfirmation = useCallback(
    (callbacks?: { onConfirm?: () => void; onDecline?: () => void }) => {
      open(callbacks ?? {});
    },
    [open]
  );

  return { isAgeConfirmed, openAgeConfirmation };
};
